import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { Input } from "sr/helpers";

type Props = {
  data: { description?: string };
  HandleDataProps: (payload: { description: string }) => void;
  externalErrorId?: string;
};

const RequirementDescriptionChange = forwardRef(({ data, HandleDataProps, externalErrorId }: Props, ref) => {
  const [description, setDescription] = useState<string>("");
  const [errorId, setErrorId] = useState<string>("");

  useEffect(() => {
    setDescription(data?.description || "");
  }, [data?.description]);

  useImperativeHandle(ref, () => ({
    validateData: () => {
      if (!description?.trim()) {
        setErrorId('INPUT.VALIDATION.REQUIREMENT.DESCRIPTION');
        return false;
      }
      setErrorId("");
      return true;
    },
    submitForm: () => {
      const newData = { description: description.trim() };
      HandleDataProps(newData);
      return newData;
    },
  }));

  return (
    <div className="space-y-6">
      <Input
        name="description"
        value={description}
        onChange={(e: any) => setDescription(e.target.value)}
        placeholder="Requirement description"
        error={externalErrorId || errorId}
      />
    </div>
  );
});

export default RequirementDescriptionChange;
